import {
  confMon as confMonApi,
  confMute as confMuteApi,
  confRecord as confRecordApi,
  confLock as confLockApi,
  confClose as confCloseApi,
  partyMute as partyMuteApi,
  muteMore as muteMoreApi,
  partyHangup as partyHangupApi,
  confUpdateGuestMuteOverride as confUpdateGuestMuteOverrideApi,
  callOut as callOutApi,
  callOutOther as callOutOtherApi,
  addOtherParty as addOtherPartyApi,
  cancelCallout as cancelCalloutApi,
  playWaitLine as playWaitLineApi,
  removeParties as removePartiesApi,
  queryGroupList as queryGroupListApi,
  queryContactList as queryContactListApi,
  queryMoreContactGroup as queryMoreContactGroupApi,
  queryContactListPage as queryContactListPageApi,
  updateRole as updateRoleApi,
  saveToAddress as saveToAddressApi,
  updatePartyInfo as updatePartyInfoApi,
  getCurrentTime as getCurrentTimeApi
} from "@/api/conf";
import { buildConfMon } from "@/model/conf/model";
import { buildContactGroup, buildContactAddress } from "@/model/contact/model";

import {
  getMeetingMuteStatusEnable,
  getMeetingMuteStatusDisable,
  getMeetingRecordStatusEnable,
  getMeetingStopRecordStatusDisable,
  getMeetingLockStatusEnable,
  getMeetingLockStatusDisable,
  getPartyMuteStatusEnable,
  getPartyMuteStatusDisable,
  getPartyMuteOverrideStatusEnable,
  getPartyMuteOverrideStatusDisable,
  getPartyMoreMuteStatusEnable,
  getPartyMoreMuteStatusDisable,
  getPartyWaitLineStatusEnable,
  getPartyWaitLineStatusDisable
} from "@/model/conf/api";

export function queryGroupList() {
  return queryGroupListApi().then(result => {
    let groupList = [];
    if (result && result.data) {
      groupList = buildContactGroup(result.data);
    }
    return groupList;
  });
}

export function getCurrentTime() {
  return getCurrentTimeApi();
}

export function queryContactList(groupId, type = 1) {
  return queryContactListApi(groupId, type).then(result => {
    let contactList = [];
    if (result && result.data && result.data.data) {
      contactList = buildContactAddress(result.data.data);
    }
    return contactList;
  });
}

export function queryContactListPage(
  groupId,
  keyword = "",
  type = 1,
  page = 1,
  num = 5
) {
  return queryContactListPageApi(groupId, keyword, type, page, num).then(
    result => {
      let contactList = [];
      if (result && result.data && result.data.data) {
        contactList = buildContactAddress(result.data.data);
      }
      return contactList;
    }
  );
}

export function queryMoreContactGroup(groupIdList) {
  const depIdList = groupIdList.map(groupId => {
    return { depId: groupId };
  });

  return queryMoreContactGroupApi(depIdList).then(result => {
    let contactList = [];
    if (result && result.data && result.data.data) {
      contactList = buildContactAddress(result.data.data);
    }
    return contactList;
  });
}

export function confMon() {
  return confMonApi().then(result => {
    if (result) {
      const confMon = buildConfMon(result.data);
      return confMon;
    }
  });
}

export function confMuteEnable() {
  return confMuteApi(getMeetingMuteStatusEnable());
}

export function confMuteDisable() {
  return confMuteApi(getMeetingMuteStatusDisable());
}

export function confRecordEnable() {
  return confRecordApi(getMeetingRecordStatusEnable());
}

export function confRecordDisable() {
  return confRecordApi(getMeetingStopRecordStatusDisable());
}

export function confLockEnable() {
  return confLockApi(getMeetingLockStatusEnable());
}

export function confLockDisable() {
  return confLockApi(getMeetingLockStatusDisable());
}

export function confClose() {
  return confCloseApi();
}

export function partyMuteEnable(partyId) {
  return partyMuteApi(getPartyMuteStatusEnable(), partyId);
}

export function partyMuteDisable(partyId) {
  return partyMuteApi(getPartyMuteStatusDisable(), partyId);
}

export function muteMoreEnable(partyIdList) {
  return muteMoreApi(getPartyMoreMuteStatusEnable(), partyIdList);
}

export function muteMoreDisable(partyIdList) {
  return muteMoreApi(getPartyMoreMuteStatusDisable(), partyIdList);
}

export function partyHangup(partyId) {
  return partyHangupApi(partyId);
}

export function confUpdateGuestMuteOverrideEnable() {
  return confUpdateGuestMuteOverrideApi(getPartyMuteOverrideStatusEnable());
}

export function confUpdateGuestMuteOverrideDisable() {
  return confUpdateGuestMuteOverrideApi(getPartyMuteOverrideStatusDisable());
}

export function callOut(info) {
  return callOutApi(info);
}

export function callOutOther(summit, partyList) {
  return callOutOtherApi(summit, partyList);
}

export function addOtherParty(summit, partyList) {
  return addOtherPartyApi(summit, partyList);
}

export function cancelCallout(summit, partyList) {
  return cancelCalloutApi(summit, partyList);
}

export function waitLineEnable() {
  return playWaitLineApi(getPartyWaitLineStatusEnable());
}
export function waitLineDisable() {
  return playWaitLineApi(getPartyWaitLineStatusDisable());
}

export function removeParties(summit, partyList) {
  return removePartiesApi(summit, partyList);
}

export function updateRole(role, partyList) {
  return updateRoleApi(role, partyList);
}

export function saveToAddress(partyList) {
  return saveToAddressApi(partyList);
}

export function updatePartyInfo(info) {
  return updatePartyInfoApi(info);
}
